import { render, staticRenderFns } from "./InfoCard.vue?vue&type=template&id=6eb27be6&scoped=true"
import script from "./InfoCard.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./InfoCard.vue?vue&type=style&index=0&id=6eb27be6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb27be6",
  null
  
)

export default component.exports